window.addEventListener('load', (event) => {
  var currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  let product = {}

  try {
    product = JSON.parse(document.getElementById('ProductJson').innerHTML);
  } catch {

  }



  let sortingObject = {
    color: "",
    price: "",
    commPrice: ''
  }
  let sortDataArry = [];
  let elemntArray = [];
  product.variants.forEach((variant) => {
    if (variant.available) {
      let sortObj = Object.create(sortingObject);
      sortObj.color = variant.option1;
      sortObj.price = variant.price;
      sortObj.commPrice = variant.compare_at_price;
      sortDataArry.push(sortObj);
    }
  })

  const key = 'color';
  const unique = [...new Map(sortDataArry.map(item =>
    [item[key], item])).values()];

  var grouped = _.mapValues(_.groupBy(unique, 'price'),
    clist => clist.map(unique => _.omit(unique, 'price')));
  if (Object.keys(grouped).length > 1) {
    var swatches = $('.Product__swatches-onpage').find(".js-ProductSwatch");
    for (let index = 0; index < swatches.length; index++) {
      const element = swatches[index];
      elemntArray.push(element);
    }
    var keys = Object.keys(grouped);
    keys.sort(function (a, b) { return b - a });
    let colorSwath = [];

    const prices = Object.keys(grouped).map(price => parseFloat(price));

// Find the lowest price
const lowestPrice = (Math.min(...prices))/100;

// Retrieve the object(s) corresponding to the lowest price
const lowestPriceObjects = grouped[lowestPrice];


    for (var i = 0; i < keys.length; i++) {
      var val = grouped[keys[i]];
      let comPrice = val[0].commPrice > keys[i] ? val[0].commPrice : " ";
      let outerWrapper = "";
      let mdClass = "md-" + Math.floor(keys[i] / 100);
      let nmClass = "nm-" + Math.floor(keys[i] / 100);
      if (comPrice > 0) {
        if(lowestPrice!=(keys[i] / 100)){
          outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" }).append($("<div>", { "class": mdClass,"style": "line-height: normal;" }).append($("<span>", { "class": "product__price--old pdp_color_group_price" }).append($("<s>", {
            "tabindex": "0"
          }).text(currency.format(comPrice / 100))))).append($("<div>", {"class": mdClass,"style": "border-bottom: 0.5px solid #987d7d;line-height: initial;" }).append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100))));
        }else{
          if ((lowestPrice/(comPrice / 100))< 0.51) {
            outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" }).append($("<div>", { "class": mdClass,"style": "line-height: normal;" }).append($("<div>", {"class": mdClass+" product__price--sale ","style": "border-bottom: 0.5px solid #987d7d;line-height: initial;font-size:14px;font-weight:800;margin-top: 2px;" }).append($("<span>", { "class": "product__price--sale pdp_color_group_price product__price--sale", "tabindex": "0" })).text(currency.format(keys[i] / 100)).append($("<span>", { "class": "product__price--sale product__price--old pdp_grp_non_sale pdp_color_group_price ", "tabindex": "0" }).text(" Clearance"))));
          }else{
            outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" }).append($("<div>", { "class": mdClass,"style": "line-height: normal;" }).append($("<span>", { "class": "product__price--old pdp_color_group_price" }).append($("<s>", {
              "tabindex": "0"
            }).text(currency.format(comPrice / 100))))).append($("<div>", {"class": mdClass,"style": "border-bottom: 0.5px solid #987d7d;line-height: initial;" }).append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100))));
          }
          
         }
        
      } else {
        outerWrapper = $("<div>", { "class": "non-markdown-swt " + nmClass, "style": "position: relative; margin-right: 25px;" }).append($("<div>", { "class": nmClass, "style": "border-bottom: 0.5px solid #987d7d; " }).append($("<span>", { "class": "product__price--old pdp_grp_non_sale pdp_color_group_price ", "tabindex": "0" }).text(currency.format(keys[i] / 100)))).append($("<div>").append($("<span>", { "class": "product__price--old" }).text()));
      }
      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        for (let i = 0; i < elemntArray.length; i++) {
          const pageElement = elemntArray[i];
          if (pageElement.title == element.color) {
            pageElement.style.display = "inline-block";
            pageElement.style.position = "relative";
            if(outerWrapper!=""){
              outerWrapper.append(pageElement);
            }
            
          }
        }
      }
      colorSwath.push(outerWrapper);
    }

    let saleDiv = $("<div>", { "style": "height: fit-content;" });
    let saleNonDiv = $("<div>", { "style": "display: block" });
    for (let index = 0; index < colorSwath.length; index++) {
      const element = colorSwath[index];
      if (element.hasClass("non-markdown-swt")) {
        saleDiv.append(element);
      }
    }
    $('.Product__swatches-onpage').append(saleDiv);
    for (let index = 0; index < colorSwath.length; index++) {
      const element = colorSwath[index];
      if (element.hasClass("markdown-swt")) {
        saleNonDiv.append(element);
      }
    }
    $('.Product__swatches-onpage').append(saleNonDiv);
    document.querySelector('.Product__swatches-onpage').classList.add('display-block-pdp-swt');

    $('.Product__option Product__option--Color').css('display', 'block');
    $('.Product__option--Color').find('.Product__option-label').addClass('pdp-color-group-heading');

    let lableDv = $("<div>", { "style": "display: inline-flex;" });
    lableDv.append($('.pdp-color-group-heading').addClass('grp-lable-color grp-lable')).append($('.Product__option__color-label').addClass('grp-lable-color'))
    $('.Product__option--Color').prepend(lableDv);

  }

  var keys = Object.keys(grouped);
  keys.sort((a, b) => b - a);
  let dataValues = "";
   
  for (var i = 0; i < keys.length; i++) {
    var val = grouped[keys[i]];
    let comPrice = val[0].commPrice > keys[i] ? val[0].commPrice : " ";
    let calcValue = Math.floor(keys[i] / 100);

    if (comPrice > 0) {
      let mdClass = "md-" + calcValue;
      dataValues += mdClass + '#';
        let markdownDivs = document.querySelectorAll('.markdown-swt');

        markdownDivs.forEach(div => {
            if (div.classList.contains(mdClass)) {
                let productSwatches = div.querySelectorAll('.js-ProductSwatch');

                productSwatches.forEach(swatch => {
                    swatch.classList.add(mdClass);
                });
            }
        });

         // Add the condition for .js-ProductSwatch without .markdown-swt or .non-markdown-swt
      let samePriceSwatches = document.querySelectorAll('.js-ProductSwatch');
      samePriceSwatches.forEach(swatch => {
        if (!swatch.closest('.markdown-swt') && !swatch.closest('.non-markdown-swt')) {
          swatch.classList.add(mdClass);
          swatch.classList.add('samePrice');
        }
      });
    } else {
      let nmClass = "nm-" + calcValue;
      dataValues += nmClass + '#';
        let nonMarkdownDivs = document.querySelectorAll('.non-markdown-swt');
        nonMarkdownDivs.forEach(div => {
          if (div.classList.contains(nmClass)) {
            let productSwatches = div.querySelectorAll('.js-ProductSwatch');

            productSwatches.forEach(swatch => {
                swatch.classList.add(nmClass);
            });
          }
        });

      // Add the condition for .js-ProductSwatch without .markdown-swt or .non-markdown-swt
      let samePriceSwatches = document.querySelectorAll('.js-ProductSwatch');
      samePriceSwatches.forEach(swatch => {
        if (!swatch.closest('.markdown-swt') && !swatch.closest('.non-markdown-swt')) {
          swatch.classList.add(nmClass);
          swatch.classList.add('samePrice');
        }
      });
    }

}

  // Get all elements with the class 'samePrice'
  let samePriceElements = document.querySelectorAll('.samePrice');

  dataValues = dataValues.slice(0, -1);

    samePriceElements.forEach(swatch => {
      swatch.setAttribute('data-group', dataValues);
      swatch.classList.add('price-tag');
      
  });
  


  document.querySelectorAll('.markdown-swt *, .non-markdown-swt *').forEach(element => {
    element.setAttribute('data-group', dataValues);

    element.classList.add('price-tag');
  });

  var priceList = dataValues.split('#');
 
  var allPriceTagElements = document.querySelectorAll('.price-tag');

  var priceGroupsElements = [];

  priceList.forEach(classInList => {
    let elementsWithClass = Array.from(allPriceTagElements).filter(element => element.classList.contains(classInList));

    if (elementsWithClass.length > 0) {
      priceGroupsElements.push(elementsWithClass);
    }
  });

  let singlePriceAvailable = false;
  const valueLabel = document.querySelector('.color-value-spn');
  const colorLabel = document.querySelector('.color-label');
  const focusableSelector = 'input, span, button, textarea, select, a[href], [tabindex]:not([tabindex="-1"]), [tabindex="0"]';

  // Add event listeners to each element in each group
  priceGroupsElements.forEach((priceGroup, groupIndex) => {
    priceGroup.forEach((element, index) => {
      element.addEventListener('keydown', event => handleTabShiftKeyDown(event, index, groupIndex, priceGroup));
      if (element.classList.contains('samePrice')) {
       singlePriceAvailable = true;
    }
    });
  });


  if (singlePriceAvailable) {
    valueLabel.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        event.preventDefault();
        if (event.shiftKey) {
          colorLabel.focus();
        }
        else {
          setFocusToElement(priceGroupsElements[0][0], focusableSelector);
        }
      }
    });

  }



  // Function to be called when Tab or Tab+Shift is pressed on elements of priceGroupsElements
  function handleTabShiftKeyDown(event, index, groupIndex, priceGroup) {

    if (event.key === 'Enter') {
      // Prevent default action for Enter key
      event.preventDefault();
    }

    if (event.key === "Tab") {
      event.preventDefault();

      if (event.shiftKey) {
        if (index > 0) {
          const previousElement = priceGroup[index - 1];
          setFocusToElement(previousElement, focusableSelector);
        } else if (groupIndex > 0) {
          const previousGroup = priceGroupsElements[groupIndex - 1];
          const lastElementOfPreviousGroup = previousGroup[previousGroup.length - 1];
          setFocusToElement(lastElementOfPreviousGroup, focusableSelector);
        } else {
          // If first element of the first group
          if (valueLabel) {
            valueLabel.focus();
          }
        }
      } else {
        if (index < priceGroup.length - 1) {
          const nextElement = priceGroup[index + 1];
          setFocusToElement(nextElement, focusableSelector);
        } else if (groupIndex < priceGroupsElements.length - 1) {
          const nextGroup = priceGroupsElements[groupIndex + 1];
          const firstElementOfNextGroup = nextGroup[0];
          setFocusToElement(firstElementOfNextGroup, focusableSelector);
        } else {
          // If last element of the last group
          var sizeLabel = document.querySelector('legend.form__label.size-lbl-pdp');
          if (sizeLabel) {
            sizeLabel.focus();
          }
        }
      }
    } else {
    }
  }

  function setFocusToElement(element, focusableSelector) {
    let focusTarget = element.querySelector(focusableSelector);

    if (focusTarget) {
      focusTarget = focusTarget.querySelector(focusableSelector) || focusTarget;
    } else {
      focusTarget = element;
    }
    focusTarget.focus();
  }


  let searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('variant')) {
    let param = searchParams.get('variant');
    let currentObject = product.variants.find(item => item.id == param);
    let currentId = "";
    if (currentObject != null) {
      currentId = currentObject.option1
    }
    if (currentId != "") {
      $('.thumbnail-list__item').removeClass('hide-imgs');
      $('.thumbnail-list__item').each(function () {
        let dataValue = $(this).data("varinet-id");
        if (currentId != dataValue) {
          $(this).addClass("hide-imgs");
        }
        if (dataValue.indexOf(".mp4") !== -1) {
          $(this).removeClass("hide-imgs");
        }
        if (dataValue.toLowerCase().indexOf("common") !== -1) {
          $(this).removeClass("hide-imgs");
        }

      })
    }

  }

});

$('.product__swatch_color').on('click', function () {
  let color = $(this).attr('title');
  $('.js-colorLabel').find('.color-value-spn').text(color);
  console.log(color);
})

$('.product__swatch_color').on('keypress', function (event) {
  console.log(color);
  if (event.key === '') {
      event.preventDefault();
      let color = $(this).attr('title');
      $('.js-colorLabel').find('.color-value-spn').text(color);
  }
});



$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('#scroll').fadeIn();
    } else {
      $('#scroll').fadeOut();
    }
  });
  $('#scroll').click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const colorSpan = document.querySelector('.color-value-spn');
  const colorLabel = document.querySelector('.color-label');
  const descriptionDiv = document.querySelector('.desc-frist');


  if (colorSpan && !colorSpan.hasAttribute('tabindex')) {
    colorSpan.setAttribute('tabindex', '0');
  }
  if (colorLabel && !colorLabel.hasAttribute('tabindex')) {
    colorLabel.setAttribute('tabindex', '0');
  }

  if (colorSpan) {
    colorSpan.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && event.shiftKey) {
        event.preventDefault();
        colorLabel.focus();
      }
    });
  }

  if (colorLabel) {
    colorLabel.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && event.shiftKey) {
        event.preventDefault();
        descriptionDiv.focus();
      }
    });
  }

  /*     Sizes List Tab Nav PDP    */
  var sizeLabel = document.querySelector('legend.form__label.size-lbl-pdp');
  var sizeInputs = document.querySelectorAll('fieldset.product-form__input input[name="Size"]');

  var sizeFit = document.getElementById('open_popup_2');

  sizeInputs.forEach(input => {
    if (input.classList.contains('disabled')) {
      // Append "Sold Out" to the existing aria-label
      let existingAriaLabel = input.getAttribute('aria-label');
      input.setAttribute('aria-label', existingAriaLabel + " Sold Out");
    }
  });


  //Size label to last swatch
  if (sizeLabel) {
    sizeLabel.addEventListener('keydown', function (event) {

      if (event.key === 'Tab' && event.shiftKey) {
        const activeElement = document.activeElement;

        if (activeElement.classList.contains('form__label')) {
          event.preventDefault();

          const radios = Array.from(document.querySelectorAll('.js-ProductSwatch input[type="radio"]'));
          if (radios.length > 0) {
            radios[radios.length - 1].focus();
          } else {
            console.error("No radio buttons found.");
          }
        }
      }
    });

    sizeLabel.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        if (sizeInputs.length > 0) {
          sizeInputs[0].focus();
        }
      }
    });
  }

  //Backward focus to SizeFit to last size option
  if (sizeFit) {
    sizeFit.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && event.shiftKey) {
        event.preventDefault();
        if (sizeInputs.length > 0) {
          sizeInputs[sizeInputs.length - 1].focus();
        }
      }
    });
  }

  sizeInputs.forEach(input => {
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        // Prevent default action for Enter key
        event.preventDefault();
      }
      if (event.key === 'Tab') {
        event.preventDefault();
        focusNextElement(event.target, sizeInputs, event.shiftKey, sizeFit, sizeLabel);
      }
    });
  });

  /* Gift Card Prices/Values List Tab Nav */
  var valueInputs = document.querySelectorAll('.value-container input[name="Value"]');
  var valueLabelGift = document.querySelector('legend.form__label.value-lbl-pdp');
  var parentElement = document.querySelector('product-info[data-url="/products/gift-card"]');
  var qtyLabel;
  var descLabel;


  if (parentElement) {
    qtyLabel = parentElement.querySelector('label.quantity__label.form__label');
    descLabel = parentElement.querySelector('div.desc-frist');
  }

  if (valueLabelGift) {
    valueLabelGift.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          event.preventDefault();
          if (descLabel) {
            descLabel.focus();
          }
        } else {
          event.preventDefault();
          if (valueInputs.length > 0) {
            valueInputs[0].focus();
          }
        }
      }
    });
  }


  valueInputs.forEach(input => {
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        // Prevent default action for Enter key
        event.preventDefault();
      }
  
      if (event.key === 'Tab') {
        event.preventDefault();
        focusNextElement(event.target, valueInputs, event.shiftKey, qtyLabel, valueLabelGift);
      }
    });
  });

  //Backward focus to qtyLabel to last price option
  if (qtyLabel) {
    qtyLabel.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && event.shiftKey) {
        event.preventDefault();
        if (valueInputs.length > 0) {
          valueInputs[valueInputs.length - 1].focus();
        }
      }
    });
  }



});




function focusNextElement(currentElement, elementsArray, goBackwards = false, elementAfterList, elementBeforeList) {
  let currentIndex = Array.prototype.indexOf.call(elementsArray, currentElement);
  let nextIndex;

  if (!goBackwards) {
    nextIndex = (currentIndex + 1) % elementsArray.length;
    if (currentIndex === elementsArray.length - 1) {
      if (elementAfterList) {
        elementAfterList.focus();
        return;
      }
    }
  } else {
    nextIndex = (currentIndex - 1 + elementsArray.length) % elementsArray.length;
    if (currentIndex === 0) {
      if (elementBeforeList) {
        elementBeforeList.focus();
        return;
      }
    }
  }

  elementsArray[nextIndex].focus();
}






